module.exports = __webpack_public_path__ + "static/media/Inspiration.bc71288d.png";